import {Component, OnInit} from '@angular/core';
import {EnterpriseService} from '../../../service/enterprise.service';
import {Constant} from '../../../../global/util/Constant';
import {Page} from '../../../../global/util/enum/Page';
import {InformType} from '../../../../global/util/enum/InformType';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddEditEnterpriseComponent} from '../add-edit-enterprise/add-edit-enterprise.component';
import {Enterprise} from '../../../model/Enterprise';
import {DeleteEnterpriseComponent} from '../delete-enterprise/delete-enterprise.component';
import {ApplicationService} from '../../../service/application.service';
import {AuthService} from '../../../service/auth/auth.service';
import {CloneTool} from '../../../../global/util/CloneTool';
import {Partner} from '../../../model/Partner';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Dialog} from '../../../../global/util/Dialog';
import {AssignBalanceEnterpriseComponent} from '../assign-balance-enterprise/assign-balance-enterprise.component';
import {ViewHistoricalBalanceComponent} from '../view-historical-balance/view-historical-balance.component';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-list-enterprise',
  templateUrl: './list-enterprise.component.html',
  styleUrls: ['./list-enterprise.component.css']
})
export class ListEnterpriseComponent implements OnInit {
  public enterprises: Enterprise[] = [];
  public page: any = {};
  public links: any = {};
  private enterpriseUrl: string;
  public enumPage = Page;
  public loading: boolean;
  public title = 'TITLE.ENTERPRISE';
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public partnerSelected: Partner;
  public partners: Partner[];
  private partnerIdSelected: number;
  public isCustomer = true;
  public term2Search: string;
  private loadingCopyClipboard: boolean;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(private enterpriseService: EnterpriseService,
              private modalService: NgbModal,
              private applicationService: ApplicationService,
              private authenticationService: AuthService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[0].value;
    this.loadDefaultData();
    this.setDefaultData();
    this.getEnterprises(Page.First);
  }

  private loadDefaultData(): void {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners().sort();
    }
  }

  private setDefaultData(): void {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.partnerIdSelected = this.partnerSelected.id;
    } else {
      this.partnerIdSelected = LocalStorage.getPartnerId();
    }
  }

  public getEnterprises(page: Page): void {
    this.term2Search = this.term2Search === undefined ? '' : this.term2Search;
    const onlycustomers = this.hasRole(this.ROLE_ADMIN) ? 'all' : this.isCustomer ? 'yes' : 'no';
    this.enterprises = [];
    switch (page) {
      case Page.First:
        this.enterpriseUrl = Constant.ROOT_API_V1.concat('/partners/', String(this.partnerIdSelected), '/enterprises?onlycustomers=', onlycustomers, '&term2Search=', this.term2Search).concat('&size=').concat(this.pageNumber).concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.enterpriseUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.enterpriseUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.enterpriseUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.enterpriseUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.loading = true;
    this.enterpriseService.get(this.enterpriseUrl).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.enterprises = next._embedded.enterprises;
      }
      this.page = next.page;
      this.links = next._links;
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.ENTERPRISE'));
    });
  }

  openAddModal() {
    this.title = this.translate.instant('TITLE.ENTERPRISE');
    const modalRef = this.modalService.open(AddEditEnterpriseComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.enterprise = new Enterprise();
    modalRef.componentInstance.enterprises = this.enterprises;
    modalRef.result.then((result) => {
      const informType = result.informType;
      if (InformType.Success === informType) {
        if (result.enterprise.isPartner) {
          this.updatePartnerEmbeddedValuesByEnterprise(result.enterprise, Constant.ADD);
          this.getEnterprises(Page.First);
        } else {
          this.getEnterprises(Page.Self);
        }
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === informType) {
        Dialog.show(InformType.Danger, this.title);
      } else if (InformType.Warning === informType) {
        Dialog.show(InformType.Warning, this.title, this.translate.instant('MESSAGE.ENTERPRISE-IS-ALREADY-REGISTERED'));
      }
    });
  }

  public openModalEdit(enterprise: Enterprise): void {
    this.title = this.translate.instant('TITLE.ENTERPRISE');
    const modalRef = this.modalService.open(AddEditEnterpriseComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.enterprise = CloneTool.do(enterprise);
    modalRef.result.then((result) => {
      const informType = result.informType;
      if (InformType.Success === informType) {
        this.updatePartnerEmbeddedValuesByEnterprise(result.enterprise, Constant.EDIT);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Warning === informType) {
        Dialog.show(InformType.Warning, this.title, result.message);
      }
    });
  }

  public openModalAssignBalance(enterprise: Enterprise): void {
    this.title = this.translate.instant('TITLE.ENTERPRISE');
    const modalRef = this.modalService.open(AssignBalanceEnterpriseComponent, {
      backdrop: 'static',
      size: 'sm'
    });
    modalRef.componentInstance.enterprise = enterprise;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.getEnterprises(Page.Self);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public openModalViewHistoricalBalance(enterprise: Enterprise): void {
    const modalRef = this.modalService.open(ViewHistoricalBalanceComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.enterpriseId = enterprise.id;
    modalRef.result.then(() => {
    });
  }

  public delete(enterprise: Enterprise): void {
    this.title = this.translate.instant('TITLE.ENTERPRISE');
    const modalRef = this.modalService.open(DeleteEnterpriseComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.enterprise = enterprise;
    modalRef.result.then((result) => {
      if (InformType.Success === result.informType) {
        this.loadActualBalance();
        if (result.enterprise1.isPartner) {
          this.updatePartnerEmbeddedValuesByEnterprise(result.enterprise1, Constant.DELETE);
          this.getEnterprises(Page.First);
        } else {
          this.getEnterprises(Page.Self);
        }
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.title, this.translate.instant('MESSAGE.ENTERPRISE-CANNOT-BE-DELETED'));
      }
    });
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  public hasRole(roleDescription: string): boolean {
    return this.authenticationService.hasRole(roleDescription);
  }

  public reloadEnterprises() {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partnerIdSelected = this.partnerSelected.id;
    } else {
      this.partnerIdSelected = LocalStorage.getPartnerId();
    }
    this.getEnterprises(Page.First);
  }

  get coin(): string {
    return Constant.IOFE_COIN;
  }

  public isntPartner(enterprise: Enterprise): boolean {
    return !this.isPartner(enterprise);
  }

  public isPartner(enterprise: Enterprise): boolean {
    return enterprise.isPartner;
  }

  public isOnlyEnterprise(enterprise: Enterprise): boolean {
    return enterprise.isCustomer && this.isntPartner(enterprise);
  }

  private loadActualBalance(): void {
    if (!LocalStorage.showBalanceInfo()) {
      return;
    }
    const url = Constant.ROOT_API_V1 + '/actualbalance';
    this.applicationService.get(url).subscribe((value: any) => {
      LocalStorage.setUpEmbeddedInfo(value);
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.CURRENT-BALANCE'));
    });
  }

  public onlyCustomersClic(event): void {
    this.isCustomer = event.target.checked;
    this.reloadEnterprises();
  }

  public isAllowedEdit(enterprise: Enterprise): boolean {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      return true;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      return enterprise.partnerId === LocalStorage.getPartnerId();
    } else if (this.hasRole(this.ROLE_ADMIN)) {
      return enterprise.partnerId === LocalStorage.getPartnerId() && enterprise.createdByPersonId === LocalStorage.getPersonId();
    }
    return false;
  }

  public balance(enterprise: Enterprise): string {
    if (!this.hasRole(this.ROLE_ADMIN) && enterprise.isCustomer && enterprise._more.hasConfigBalance) {
      return enterprise._more.balance.toFixed(2);
    }
    return '-';
  }

  get showBalanceInfo() {
    return LocalStorage.showBalanceInfo();
  }

  private updatePartnerEmbeddedValuesByEnterprise(enterprise: Enterprise, action) {
    let index;
    const partner = ({
      id: enterprise.partnerId,
      name: enterprise.name,
      createAt: undefined,
      active: 1
    });
    switch (action) {
      case Constant.ADD :
        LocalStorage.updateEmbeddedValuesBy(partner, 'partners', Constant.ADD);
        this.loadDefaultData();
        index = this.partners.findIndex(partner1 => partner1.id === enterprise.partnerId);
        this.partnerSelected = this.partners[index];
        this.partnerIdSelected = this.partnerSelected.id;
        break;
      case Constant.EDIT :
        let page = Page.First;
        const oldEnterprise = LocalStorage.getEnterprises().find(obj => obj.id === enterprise.id);
        if (enterprise.isPartner && !oldEnterprise.isPartner) {
          LocalStorage.updateEmbeddedValuesBy(partner, 'partners', Constant.ADD);
        } else if (enterprise.isPartner && oldEnterprise.isPartner) {
          LocalStorage.updateEmbeddedValuesBy(partner, 'partners', Constant.EDIT);
        } else if (!enterprise.isPartner && oldEnterprise.isPartner) {
          partner.id = oldEnterprise.partnerId;
          partner.name = oldEnterprise.name;
          LocalStorage.updateEmbeddedValuesBy(partner, 'partners', Constant.DELETE);
        } else if (!enterprise.isPartner && !oldEnterprise.isPartner) {
          page = Page.Self;
        }
        LocalStorage.updateEmbeddedValuesBy(enterprise, 'enterprises', Constant.EDIT);
        this.loadDefaultData();
        if (this.hasRole(this.ROLE_SUPERADMIN)) {
          index = this.partners.findIndex(partner1 => partner1.id === enterprise.partnerId);
          if (index === -1) {
            this.partnerSelected = this.partners[Constant.ZERO_INDEX];
          } else {
            this.partnerSelected = this.partners[index];
          }
          this.partnerIdSelected = this.partnerSelected.id;
        }
        this.getEnterprises(page);
        break;
      case Constant.DELETE :
        LocalStorage.updateEmbeddedValuesBy(partner, 'partners', Constant.DELETE);
        this.loadDefaultData();
        this.partnerSelected = this.partners[Constant.ZERO_INDEX];
        this.partnerIdSelected = this.partnerSelected.id;
        break;
    }
  }

  get hasConfigBalance(): boolean {
    return LocalStorage.hasConfigBalance();
  }

  showLimitStorage(enterprise: Enterprise) {
    return enterprise._more.limitStorage ? enterprise._more.limitStorage + ' ' + this.getUnitType(enterprise) : '-';
  }

  getUnitType(enterprise: Enterprise) {
    return LocalStorage.getStorageTypes().find(unitType => unitType.id === enterprise._more.storageType).name;
  }

  customLinkIsPresent(enterprise: Enterprise) {
    return enterprise._more.customLink;
  }

  copyToClipboard(enterprise: Enterprise) {
    const textAreaElement = document.createElement('textarea');
    textAreaElement.style.position = 'fixed';
    textAreaElement.style.left = '0';
    textAreaElement.style.top = '0';
    textAreaElement.style.opacity = '0';
    textAreaElement.value = enterprise._more.customLink;
    document.body.appendChild(textAreaElement);
    textAreaElement.focus();
    textAreaElement.select();
    document.execCommand('copy');
    document.body.removeChild(textAreaElement);
    this.loadingCopyClipboard = true;
    setTimeout(() => {
      this.loadingCopyClipboard = false;
    }, 300);
  }
}
